import React from 'react';
import Login from '../../components/extern/LoginRegisterReset/Login';

const LoginPage = () => {
  return (
    <main>
      <Login />
    </main>
  );

};

export default LoginPage;
